import axios from "axios";

const API_KEY = process.env.REACT_APP_TMDB_API_KEY || "97a6e9005033f933a55fa7cce6d9fdf5";
export const DEFAULT_LANGUAGE = "pt-BR";

const api = axios.create({
  baseURL: "https://api.themoviedb.org/3/",
  timeout: 10000,
});

api.interceptors.request.use((config) => ({
  ...config,
  params: {
    api_key: API_KEY,
    language: DEFAULT_LANGUAGE,
    include_adult: false,
    ...config.params,
  },
}));

export { API_KEY };
export default api;
